class VacCartRewardMoney {
  static format(cents) {
    const amount = Number(cents) || 0;
    const moneyFormat = window.spratlyThemeSettings?.money_format;

    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && moneyFormat) {
      return window.Shopify.formatMoney(amount, moneyFormat);
    }

    return `${new Intl.NumberFormat('ro-RO', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount / 100)} lei`;
  }
}

class VacCartReward {
  constructor(el) {
    this.el = el;
    this.goal = Number.parseInt(el.dataset.goal, 10) || 0;
    this.messageEl = el.querySelector('[data-vac-cart-reward-message]');
    this.fillEl = el.querySelector('[data-vac-cart-reward-fill]');
    this.markerEl = el.querySelector('[data-vac-cart-reward-marker]');
    this.totalEl = el.querySelector('[data-vac-cart-reward-total]');

    if (!this.goal || !this.messageEl || !this.fillEl || !this.markerEl || !this.totalEl) return;

    this.update(Number.parseInt(el.dataset.cartTotal, 10) || 0);
  }

  static initAll(root = document) {
    root.querySelectorAll('[data-vac-cart-reward]').forEach((el) => {
      if (!el.__vacCartReward) {
        el.__vacCartReward = new VacCartReward(el);
      }
    });
  }

  static updateAll(cart) {
    const total = Number(cart?._foxCartPrices?.total_price || cart?.total_price || 0);

    document.querySelectorAll('[data-vac-cart-reward]').forEach((el) => {
      if (!el.__vacCartReward) {
        el.__vacCartReward = new VacCartReward(el);
      }

      el.__vacCartReward?.update(total);
    });
  }

  update(cartTotal) {
    const total = Math.max(Number(cartTotal) || 0, 0);
    const remaining = Math.max(this.goal - total, 0);
    const progress = Math.min((total / this.goal) * 100, 100);
    const progressValue = `${progress.toFixed(2)}%`;
    const isComplete = remaining <= 0;

    this.el.dataset.cartTotal = String(total);
    this.el.classList.toggle('is-complete', isComplete);
    this.fillEl.style.width = progressValue;
    this.markerEl.style.left = progressValue;
    this.totalEl.textContent = VacCartRewardMoney.format(total);

    this.messageEl.innerHTML = isComplete
      ? 'Esti inscris automat in campanie'
      : `Mai adaugi inca <strong>${VacCartRewardMoney.format(remaining)}</strong> pentru a participa automat`;
  }
}

class VacCartRewardBootstrap {
  constructor() {
    this.handleCartChange = this.handleCartChange.bind(this);
    this.fetchAndUpdate = this.fetchAndUpdate.bind(this);
    this.init();
  }

  init() {
    const run = (root = document) => VacCartReward.initAll(root);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => run(), { once: true });
    } else {
      run();
    }

    this.subscribeThemeEvents();
    document.addEventListener('cartAdded', this.fetchAndUpdate);
    document.addEventListener('cartUpdated', this.fetchAndUpdate);

    if (!document.body) return;

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof HTMLElement)) return;

          if (node.matches('[data-vac-cart-reward]')) {
            run(node.parentElement || document);
            return;
          }

          if (node.querySelector('[data-vac-cart-reward]')) {
            run(node);
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  subscribeThemeEvents() {
    const subscribe = () => {
      if (!window._ThemeEvent?.subscribe) return false;

      window._ThemeEvent.subscribe('ON_CART_UPDATE', this.handleCartChange);
      window._ThemeEvent.subscribe('ON_FOX_CART_UPDATE', this.handleCartChange);
      return true;
    };

    if (!subscribe()) {
      window.addEventListener('load', subscribe, { once: true });
    }
  }

  handleCartChange(cart) {
    if (cart) {
      VacCartReward.updateAll(cart);
    }
  }

  async fetchAndUpdate() {
    try {
      const response = await fetch('/cart.js', { credentials: 'same-origin' });
      const cart = await response.json();

      if (response.ok) {
        VacCartReward.updateAll(cart);
      }
    } catch (error) {
      console.error('[VacCartReward] cart update error', error);
    }
  }
}

if (!window.__vacCartRewardBootstrap) {
  window.__vacCartRewardBootstrap = new VacCartRewardBootstrap();
}
